import { notify } from 'utils/reduxUtils';

export const types = {
  CONTOUR_SELECTOR_RECEIVE_EXCLUDED_KEYS:
    'vectorFileEditor/CONTOUR_SELECTOR_RECEIVE_EXCLUDED_KEYS',
  CONTOUR_SELECTOR_RECEIVE_HIDE_EXCLUDED:
    'vectorFileEditor/CONTOUR_SELECTOR_RECEIVE_HIDE_EXCLUDED',
  CONTOUR_SELECTOR_REDO: 'vectorFileEditor/CONTOUR_SELECTOR_REDO',
  CONTOUR_SELECTOR_UNDO: 'vectorFileEditor/CONTOUR_SELECTOR_UNDO',

  INIT_VECTOR_EDITOR: 'vectorFileEditor/INIT_VECTOR_EDITOR',
  INIT_VECTOR_EDITOR_FROM_STATUS_CHANGE:
    'vectorFileEditor/INIT_VECTOR_EDITOR_FROM_STATUS_CHANGE',

  MAKE_DXF_REQUEST: 'vectorFileEditor/MAKE_DXF_REQUEST',
  MAKE_DXF_SUCCESS: 'vectorFileEditor/MAKE_DXF_SUCCESS',
  MAKE_DXF_ERROR: 'vectorFileEditor/MAKE_DXF_ERROR',

  MEASUREMENT_TOOL_DISABLE: 'vectorFileEditor/MEASUREMENT_TOOL_DISABLE',
  MEASUREMENT_TOOL_ENABLE: 'vectorFileEditor/MEASUREMENT_TOOL_ENABLE',
  MEASUREMENT_TOOL_RECEIVE_COMPARISON:
    'vectorFileEditor/MEASUREMENT_TOOL_RECEIVE_COMPARISON',
  MEASUREMENT_TOOL_RECEIVE_MEASUREMENT:
    'vectorFileEditor/MEASUREMENT_TOOL_RECEIVE_MEASUREMENT',
  MEASUREMENT_TOOL_RECEIVE_SELECTIONS:
    'vectorFileEditor/MEASUREMENT_TOOL_RECEIVE_SELECTIONS',
  MEASUREMENT_TOOL_REMOVE_SELECTIONS:
    'vectorFileEditor/MEASUREMENT_TOOL_REMOVE_SELECTIONS',

  RECEIVE_DISPLAY_SCALE: 'vectorFileEditor/RECEIVE_DISPLAY_SCALE',
  RECEIVE_DISPLAY_UNITS: 'vectorFileEditor/RECEIVE_DISPLAY_UNITS',
  RECEIVE_EDGE_HIGHLIGHT: 'vectorFileEditor/RECEIVE_EDGE_HIGHLIGHT',
  RECEIVE_EDITOR_MODE: 'vectorFileEditor/RECEIVE_EDITOR_MODE',
  RECEIVE_FORCE_VIEW: 'vectorFileEditor/RECEIVE_FORCE_VIEW',
  RECEIVE_HIGHLIGHT: 'vectorFileEditor/RECEIVE_HIGHLIGHT',
  RECEIVE_META_DATA: 'vectorFileEditor/RECEIVE_META_DATA',
  RECEIVE_SCALE: 'vectorFileEditor/RECEIVE_SCALE',
  RECEIVE_SCALE_MODE: 'vectorFileEditor/RECEIVE_SCALE_MODE',
  RECEIVE_VECTORIZATION_STATUS: 'vectorFileEditor/RECEIVE_VECTORIZATION_STATUS',
  RECEIVE_VIEWER_DATA: 'vectorFileEditor/RECEIVE_VIEWER_DATA',

  RESET: 'vectorFileEditor/RESET',

  SELECTOR_TOOL_BOX_SELECT: 'vectorFileEditor/SELECTOR_TOOL_BOX_SELECT',
  SELECTOR_TOOL_CLEAR_ALL_SELECTIONS:
    'vectorFileEditor/SELECTOR_TOOL_CLEAR_ALL_SELECTIONS',
  SELECTOR_TOOL_ENABLE: 'vectorFileEditor/SELECTOR_TOOL_ENABLE',
  SELECTOR_TOOL_DISABLE: 'vectorFileEditor/SELECTOR_TOOL_DISABLE',
  SELECTOR_TOOL_RECEIVE_CUMULATIVE_INFO:
    'vectorFileEditor/SELECTOR_TOOL_RECEIVE_CUMULATIVE_INFO',
  SELECTOR_TOOL_RECEIVE_SELECTION:
    'vectorFileEditor/SELECTOR_TOOL_RECEIVE_SELECTION',
  SELECTOR_TOOL_REMOVE_SELECTION:
    'vectorFileEditor/SELECTOR_TOOL_REMOVE_SELECTION',

  UPDATE_CONTOUR_REQUEST: 'vectorFileEditor/UPDATE_CONTOUR_REQUEST',
  UPDATE_CONTOUR_SUCCESS: 'vectorFileEditor/UPDATE_CONTOUR_SUCCESS',
  UPDATE_CONTOUR_ERROR: 'vectorFileEditor/UPDATE_CONTOUR_ERROR',

  UPDATE_PAGE_VECTORIZATION_REQUEST:
    'vectorFileEditor/UPDATE_PAGE_VECTORIZATION_REQUEST',
  UPDATE_PAGE_VECTORIZATION_SUCCESS:
    'vectorFileEditor/UPDATE_PAGE_VECTORIZATION_SUCCESS',
  UPDATE_PAGE_VECTORIZATION_ERROR:
    'vectorFileEditor/UPDATE_PAGE_VECTORIZATION_ERROR',
};

export const vectorEditor = {
  init: ({
    activeEntityId,
    displayUnits,
    excludedEdgeKeys,
    mode,
    partFileUuid,
    partMasterVersion,
    partUuid,
    scale,
    totalEdgeCount,
    vectorizationStatus,
  }) => ({
    type: types.INIT_VECTOR_EDITOR,
    payload: {
      activeEntityId,
      displayUnits,
      excludedEdgeKeys,
      mode,
      partFileUuid,
      partMasterVersion,
      partUuid,
      scale,
      totalEdgeCount,
      vectorizationStatus,
    },
  }),
  initFromStatusChange: ({
    excludedEdgeKeys,
    scale,
    totalEdgeCount,
    vectorizationStatus,
  }) => ({
    type: types.INIT_VECTOR_EDITOR_FROM_STATUS_CHANGE,
    payload: { excludedEdgeKeys, scale, totalEdgeCount, vectorizationStatus },
  }),
  receiveDisplayScale: ({ displayScale }) => ({
    type: types.RECEIVE_DISPLAY_SCALE,
    payload: { displayScale },
  }),
  receiveDisplayUnits: ({ displayUnits }) => ({
    type: types.RECEIVE_DISPLAY_UNITS,
    payload: { displayUnits },
  }),
  receiveEdgeHighlight: ({ edgeHighlight }) => ({
    type: types.RECEIVE_EDGE_HIGHLIGHT,
    payload: { edgeHighlight },
  }),
  receiveEditorMode: ({ editorMode }) => ({
    type: types.RECEIVE_EDITOR_MODE,
    payload: { editorMode },
  }),
  receiveForceView: ({ forceView }) => ({
    type: types.RECEIVE_FORCE_VIEW,
    payload: { forceView },
  }),
  receiveHighlight: ({ highlight }) => ({
    type: types.RECEIVE_HIGHLIGHT,
    payload: { highlight },
  }),
  receiveMetaData: ({ metaData }) => ({
    type: types.RECEIVE_META_DATA,
    payload: { metaData },
  }),
  receiveScale: ({ scale }) => ({
    type: types.RECEIVE_SCALE,
    payload: { scale },
  }),
  receiveScaleMode: ({ scaleMode }) => ({
    type: types.RECEIVE_SCALE_MODE,
    payload: { scaleMode },
  }),
  receiveVectorizationStatus: ({ status }) => ({
    type: types.RECEIVE_VECTORIZATION_STATUS,
    payload: { status },
  }),
  receiveViewerData: ({ viewerData }) => ({
    type: types.RECEIVE_VIEWER_DATA,
    payload: { viewerData },
  }),
  reset: () => ({
    type: types.RESET,
  }),
};

export const contourSelector = {
  receiveExcludedEdgeKeys: ({ edgeKeys }) => ({
    type: types.CONTOUR_SELECTOR_RECEIVE_EXCLUDED_KEYS,
    payload: { edgeKeys },
  }),
  receiveHideExcluded: ({ hideExcluded }) => ({
    type: types.CONTOUR_SELECTOR_RECEIVE_HIDE_EXCLUDED,
    payload: { hideExcluded },
  }),
  redo: () => ({
    type: types.CONTOUR_SELECTOR_REDO,
  }),
  undo: () => ({
    type: types.CONTOUR_SELECTOR_UNDO,
  }),
};

export const makeDxf = {
  request: ({ thickness }) => ({
    type: types.MAKE_DXF_REQUEST,
    payload: { thickness },
  }),
  success: () => ({
    type: types.MAKE_DXF_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.MAKE_DXF_ERROR,
      payload: error,
    }),
    'Failed to make dxf from print',
  ),
};

export const measurementTool = {
  disable: () => ({
    type: types.MEASUREMENT_TOOL_DISABLE,
  }),
  enable: () => ({
    type: types.MEASUREMENT_TOOL_ENABLE,
  }),
  receiveComparison: ({ comparison }) => ({
    type: types.MEASUREMENT_TOOL_RECEIVE_COMPARISON,
    payload: { comparison },
  }),
  receiveMeasurement: ({ distance }) => ({
    type: types.MEASUREMENT_TOOL_RECEIVE_MEASUREMENT,
    payload: { distance },
  }),
  receiveSelections: ({ selections }) => ({
    type: types.MEASUREMENT_TOOL_RECEIVE_SELECTIONS,
    payload: { selections },
  }),
  removeSelections: () => ({
    type: types.MEASUREMENT_TOOL_REMOVE_SELECTIONS,
  }),
};

export const selectorTool = {
  boxSelect: ({ selections }) => ({
    type: types.SELECTOR_TOOL_BOX_SELECT,
    payload: { selections },
  }),
  clearAllSelections: () => ({
    type: types.SELECTOR_TOOL_CLEAR_ALL_SELECTIONS,
  }),
  disable: () => ({
    type: types.SELECTOR_TOOL_DISABLE,
  }),
  enable: () => ({
    type: types.SELECTOR_TOOL_ENABLE,
  }),
  receiveCumulativeInfo: ({ cumulativeInfo }) => ({
    type: types.SELECTOR_TOOL_RECEIVE_CUMULATIVE_INFO,
    payload: { cumulativeInfo },
  }),
  receiveSelection: ({ selection }) => ({
    type: types.SELECTOR_TOOL_RECEIVE_SELECTION,
    payload: { selection },
  }),
  removeSelection: ({ f, obj }) => ({
    type: types.SELECTOR_TOOL_REMOVE_SELECTION,
    payload: { f, obj },
  }),
};

export const updateContour = {
  request: () => ({
    type: types.UPDATE_CONTOUR_REQUEST,
  }),
  success: () => ({
    type: types.UPDATE_CONTOUR_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.UPDATE_CONTOUR_ERROR,
      payload: error,
    }),
    'Failed to update contour',
  ),
};
